export default function Area() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path
                d="M17.2172 15.7567L19.6979 13.1485C20.2261 12.5927 21.1022 12.5729 21.6553 13.1036C22.2078 13.6337 22.2283 14.5144 21.7 15.0695L16.1817 20.9974C15.4786 21.7525 14.4559 22.121 13.435 21.9858L4.71896 20.832"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.2173 15.7567L18.6528 14.2485C19.1805 13.6934 19.1607 12.8133 18.6075 12.2826C18.055 11.7518 17.1783 11.7724 16.6507 12.3275L14.2549 14.8504"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.875 17.6628H15.9316C16.696 17.6628 17.3161 17.0404 17.3161 16.2719C17.3161 15.504 16.696 14.8816 15.9316 14.8816L11.875 14.8707L10.1696 13.9893C8.95544 13.3625 7.52308 13.3272 6.2802 13.8938L4.71896 14.606"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.08095 22.2005H2.30469C1.9525 22.2005 1.66667 21.914 1.66667 21.5595V13.6376C1.66667 13.2831 1.9525 12.9966 2.30469 12.9966H4.08095C4.43314 12.9966 4.71898 13.2831 4.71898 13.6376V21.5595C4.71898 21.914 4.43314 22.2005 4.08095 22.2005Z"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7751 6.75V6.74003C15.7738 6.13743 16.0674 5.57204 16.6009 5.27041L16.8333 5.13952L15.6351 3.11048L15.3979 3.24535C14.8834 3.53502 14.2472 3.53901 13.7389 3.23871C13.6954 3.21279 13.6512 3.18821 13.6063 3.16363C13.0905 2.88459 12.7812 2.34377 12.7812 1.76775V1.5H10.3854V1.76775C10.3854 2.34377 10.0762 2.88459 9.56034 3.16363C9.51616 3.18821 9.4713 3.21279 9.42781 3.23871C8.91942 3.53901 8.28327 3.53502 7.76877 3.24535L7.53157 3.11048L6.33333 5.13952L6.56578 5.27041C7.09931 5.57204 7.39292 6.13743 7.39156 6.74003V6.75V6.75997C7.39292 7.36257 7.09931 7.92796 6.56578 8.22959L6.33333 8.36048L7.53157 10.3889L7.76877 10.2547C8.28327 9.96498 8.91942 9.96099 9.42781 10.2613C9.4713 10.2872 9.51616 10.3118 9.56034 10.3364C10.0762 10.6154 10.3854 11.1562 10.3854 11.7323V12H12.7812V11.7323C12.7812 11.1562 13.0905 10.6154 13.6063 10.3364C13.6512 10.3118 13.6954 10.2872 13.7389 10.2613C14.2472 9.96099 14.8834 9.96498 15.3979 10.2547L15.6351 10.3889L16.8333 8.36048L16.6009 8.22959C16.0674 7.92796 15.7738 7.36257 15.7751 6.75997V6.75Z"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3333 6.75C13.3333 7.71634 12.5495 8.5 11.583 8.5C10.6165 8.5 9.83333 7.71634 9.83333 6.75C9.83333 5.78366 10.6165 5 11.583 5C12.5495 5 13.3333 5.78366 13.3333 6.75Z"
                stroke="#3F68E0"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
